const env = process.env.REACT_APP_ENV;

let API_URL: string;
if (env === 'local') {
  API_URL = 'http://localhost:8080';
  //API_URL = 'http://192.168.219.178:8080';
} else if (env === 'dev') {
  API_URL = 'http://localhost:8080';
} else if (env === 'prod') {
  API_URL = 'https://api.noobook.co.kr';
} else {
  API_URL = 'https://api.example.com';
}

export { API_URL }; 